import http from '../../utils/fetch';
export default {
    baseUrl:"/api/swyl/v1/process/inst",
    page(query) {
        return http({
            url: this.baseUrl+'/selectPage',
            method: 'post',
            params: query
        });
    },
    getByid(id){
        return http({
            url: this.baseUrl+'/getByid',
            method: 'post',
            params: {id}
        });
    }

}
